import React from "react";

import { Error } from "./pages/Error";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Start } from "./pages/Start";
import { About } from "./pages/About";
import { Order } from "./pages/Order";
import { Faq } from "./pages/Faq";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Start />,
  },
  {
    path: "/order/:selectedSubscription?",
    element: <Order />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <Error error="404" variant="notFound" />,
  },
]);
export const Router = () => {
  return <RouterProvider router={router} />;
};
